module.exports = __webpack_public_path__ + "images/emoji/cherry_blossom.949e81612b0486efcd38.png";